<script lang="ts">
  export let links: { link: string; title: string; target?: string }[] = [];
  export let title = '';
</script>

<div class="text-base">
  <p class="text-dark-700 mb-4 md:mb-6">{title}</p>

  <ul class="flex flex-col gap-2.5 md:gap-3">
    {#each links as { link, title, target }}
      {@const isTargetBlank = target && target === '_blank'}

      <li>
        <a
          href="{isTargetBlank ? '' : '/'}{link}/"
          class="underline-hover after:bg-default-400 dark:after:bg-default-500 border-b capitalize after:absolute after:-bottom-[1px] after:left-0 after:right-0 after:h-[1px]"
          {target}
          rel="{isTargetBlank ? 'nofollow' : ''}"
        >
          {title}
        </a>
      </li>
    {/each}
  </ul>
</div>
